import { KVAnnotation } from 'types'

// Batch type tag constants
export const AUTOGENERATED_DEFAULT_TAG = 'Autogenerated'
export const AUTOGENERATED_DEFAULT_TAG_VALUE = 'Autogenerated'

export const AUTOGENERATED_HOTSPOT_TAG = 'Autogenerated Hotspots'
export const AUTOGENERATED_HOTSPOT_TAG_VALUE = 'Autogenerated Hotspot'

export const AUTOGENERATED_TEXT_SEGMENTATION_TAG = 'Text Segmentation'
export const AUTOGENERATED_TEXT_SEGMENTATION_TAG_VALUE = 'Text Segmentation'

// Text Segmentation prompt tag
export const TEXT_SEGMENTATION_TAG = 'Text Segmentation'

// Batch type configuration
export interface BatchTypeConfig {
  tagKey: string
  tagValue: string
  defaultLabelPrefix: string
}

export const BATCH_TYPE_CONFIGS: Record<string, BatchTypeConfig> = {
  default: {
    tagKey: AUTOGENERATED_DEFAULT_TAG,
    tagValue: AUTOGENERATED_DEFAULT_TAG_VALUE,
    defaultLabelPrefix: 'SA',
  },
  hotspot: {
    tagKey: AUTOGENERATED_HOTSPOT_TAG,
    tagValue: AUTOGENERATED_HOTSPOT_TAG_VALUE,
    defaultLabelPrefix: 'HS',
  },
  textSegmentation: {
    tagKey: AUTOGENERATED_TEXT_SEGMENTATION_TAG,
    tagValue: AUTOGENERATED_TEXT_SEGMENTATION_TAG_VALUE,
    defaultLabelPrefix: 'TS',
  },
}

export const DEFAULT_BATCH_TYPE = 'default'

/**
 * @param batchType - The batch type from JSON
 * @returns BatchTypeConfig for the specified type, or default if not found
 */
export function getBatchTypeConfig(batchType?: string): BatchTypeConfig {
  const type = batchType || DEFAULT_BATCH_TYPE
  return BATCH_TYPE_CONFIGS[type] || BATCH_TYPE_CONFIGS[DEFAULT_BATCH_TYPE]
}

/**
 * @param annotation - The annotation to check
 * @returns true if the annotation has any batch tag
 */
export function isAutogeneratedBatchAnnotation(
  annotation: KVAnnotation
): boolean {
  return Object.values(BATCH_TYPE_CONFIGS).some(
    (config) => annotation.tags[config.tagKey]?.value === config.tagValue
  )
}
